export enum Events {
  EMPTY,
  USER_SIGNED_IN,
  USER_SIGNED_OUT,
  TOKEN_EXPIRED,
}
